import { ConferenceType } from '@domain/districts/types';

export const isRemoteInfoRequired = (type: string) =>
  [ConferenceType.Hybrid, ConferenceType.Online].includes(
    type as ConferenceType
  );
